import React from 'react';
import styled from 'styled-components';
import {
  primaryColor, secondaryFont, maxWidth, retina, wMLight, maxMobile,
} from 'Utils/utilsStyle';
import ArrowDownIcon from '../assets/svgIcons/ArrowDownIcon';

type Props = {
  count: string,
  onClick: () => void,
  text?: string,
};

const defaultProps = {
  text: '',
};

const Span = styled.div`
 color: ${primaryColor};
 font-weight: ${wMLight};
 font-family: ${secondaryFont};
 font-size: 14px;
 line-height: 25px;
 text-align: center;
 display: inline-flex;
 align-items: center;
 justify-content: center;
 width: 100%;
 cursor: pointer;
 @media all and (max-width: ${maxMobile}) {
  font-size: 12px;
  line-height: 16px;
 }
 svg {
  margin-left: 10px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    margin-left: 5px;
    width: 12px;
  }
 }
`;

const ShowMoreData = function ShowMoreData(props: Props) {
  const {
    count, onClick, text,
  } = props;
  return (
    <Span onClick={onClick} className="arrow-down-icon-wrapper">
      Show
      {' '}
      all
      {' '}
      {count}
      {' '}
      {!text && 'more'}
      {text && text}
      <ArrowDownIcon />
    </Span>
  );
};
ShowMoreData.defaultProps = defaultProps;
export default ShowMoreData;
